import {
  BookOpenIcon,
  GraduationCapIcon,
  type LucideIcon,
  ShieldCheckIcon,
  ShieldIcon,
} from "lucide-react";
import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";
import type { UserRole } from "@/types";

/**
 * Ranglar `src/index.css` dagi rol tokenlaridan keladi. Ilgari bu yerda
 * to'g'ridan-to'g'ri `violet-500` / `amber-500` / `sky-500` / `emerald-500`
 * turardi — palitradan tashqaridagi to'rtta rang, ular almashtirilganda
 * hech kim topa olmaydigan joyda.
 */
const ROLE_META: Record<UserRole, { icon: LucideIcon; className: string }> = {
  admin: { icon: ShieldIcon, className: "bg-role-admin-soft text-role-admin" },
  moderator: { icon: ShieldCheckIcon, className: "bg-role-moderator-soft text-role-moderator" },
  teacher: { icon: GraduationCapIcon, className: "bg-role-teacher-soft text-role-teacher" },
  student: { icon: BookOpenIcon, className: "bg-role-student-soft text-role-student" },
};

interface RoleBadgeProps {
  role?: UserRole;
  /** Faqat ikonka (yorliqsiz) — tor joylarda qulay. */
  iconOnly?: boolean;
  className?: string;
}

/** Rangli rol nishoni — rol ikonkasi va tarjima qilingan yorlig'i bilan. */
export const RoleBadge = ({ role, iconOnly, className }: RoleBadgeProps) => {
  const { t } = useTranslation();
  if (!role) return null;
  const meta = ROLE_META[role];
  const Icon = meta.icon;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold",
        meta.className,
        className,
      )}
    >
      <Icon className="size-3 shrink-0" />
      {!iconOnly && t(`ROLES.${role.toUpperCase()}`)}
    </span>
  );
};
